<template>
  <div>
    <form-input
      v-model="model"
      class="_border-sm _border-gray-300 _rounded-md"
      :class="inputClass"
      :placeholder="placeholder">
    </form-input>
    <input-error-common :showError="showError" :errorMsg="errorMessage.link"/>
  </div>
</template>

<script>

  import InputErrorCommon from 'core/components/InputErrorCommon/InputErrorCommon'

  export default {
    name: 'form-input-url',
    components: {
      InputErrorCommon
    },
    props: {
      value: {},
      placeholderStr: () => (''),
      showError: () => (false),
      inputClass: () => ('')
    },
    data () {
      return {
        placeholder: this.placeholderStr || this.$t('inputPlaceholders.url'),
        errorMessage: {
          link: this.$t('errorMessages.inputErrors.url')
        }
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$nextTick(() => {
            this.$emit('input', value)
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';
  @import '../form-field-default.scss';
</style>
